import { BrowserRouter, Route, Routes } from "react-router-dom";
import { ScrollToTop } from "./components/ScrollToTop";

import Feed from "./pages/Feed";
import GlobalFeed from "./pages/GlobalFeed";
import Upload from "./pages/Upload";
import MyAlbums from "./pages/MyAlbums";
import AlbumDetail from "./pages/AlbumDetail";
import HashtagFeed from "./pages/HashtagFeed";
import SearchPage from "./pages/SearchPage";
import ThemesPage from "./pages/ThemesPage";
import { NIP19Page } from "./pages/NIP19Page";
import NotFound from "./pages/NotFound";

export function AppRouter() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Feed />} />
        <Route path="/global" element={<GlobalFeed />} />
        <Route path="/upload" element={<Upload />} />
        <Route path="/album" element={<MyAlbums />} />
        <Route path="/search" element={<SearchPage />} />
        <Route path="/tag/:tag" element={<HashtagFeed />} />
        <Route path="/themes" element={<ThemesPage />} />
        {/* Album detail — must be above the NIP-19 catch-all */}
        <Route path="/:npub/albums/:slug" element={<AlbumDetail />} />
        {/* NIP-19 route for npub1, note1, naddr1, nevent1, nprofile1 */}
        <Route path="/:nip19" element={<NIP19Page />} />
        {/* ADD ALL CUSTOM ROUTES ABOVE THE CATCH-ALL "*" ROUTE */}
        <Route path="*" element={<NotFound />} />
      </Routes>
    </BrowserRouter>
  );
}
export default AppRouter;
